module.exports = __webpack_public_path__ + "static/media/topassister.dab62e3a.jpg";